// KEY phải là dạng chuẩn hóa (không dấu, không khoảng trắng, lowercase, nối bằng "-")
// Ví dụ: "Chuyên Khoa" => "chuyen-khoa"

const namingRules = {
  "chuyen-khoa": {
    prefix: "CK",
    nameLabel: "tên chuyên khoa",
    example: "khoanhi",
  },

  "khoa-nhi": {
    prefix: "NI",
    nameLabel: "tên khoa nhi",
    example: "tieuhoa",
  },

  "khoa-san": {
    prefix: "SAN",
    nameLabel: "tên khoa sản",
    example: "sankhoa",
  },

  "anh-nhan-vien": {
    prefix: "NV",
    nameLabel: "mã nhân viên",
    example: "00949",
  },

  "hdtv": {
    prefix: "GD",
    nameLabel: "tên HDTV",
    example: "NguyenThi",
  },

  "bgd": {
    prefix: "BS",
    nameLabel: "tên Ban Giám Đốc",
    example: "NguyenGiaBinh",
  },
};

export default namingRules;
